import React, { Component } from 'react';
import AfshanRug from './rugTemplates/afshanRug';
import KheshtiRug from './rugTemplates/kheshtiRug';
import LachakToranjRug from './rugTemplates/lachakToranjRug';
import ModernRug from './rugTemplates/modernRug';

export default class SelectedRugsMobileSidebar extends Component {

    render() {
        let rugs = [];
        this.props.rugs.map((rug, i) => {
            let key = rug.type + i
            switch (rug.type) {
                case "lachak-toranj":
                    rugs.push(
                        <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <LachakToranjRug
                                background={rug.background}
                                border={rug.border}
                                corner={rug.corner}
                                toranj={rug.toranj}
                                show={true}
                            />
                        </div>
                    )
                    break;
                case "kheshti":
                    rugs.push(
                        <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <KheshtiRug
                                background={rug.background}
                                tile={rug.tile}
                                show={true}
                            />
                        </div>
                    )
                    break;
                case "modern":
                    rugs.push(
                        <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <ModernRug
                                background={rug.background}
                                tile={rug.tile}
                                show={true}
                            />
                        </div>
                    )
                    break;
                case "your_picture":
                    rugs.push(
                        <div className="check" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <ModernRug
                                background={rug.background}
                                tile={rug.tile}
                                show={true}
                            />
                        </div>
                    )
                    break;
                default:
                    rugs.push(
                        <div className="check active" key={key} onClick={() => this.props.clickHandler(rug, i)}>
                            {/* <span> 23%</span> */}
                            <AfshanRug
                                background={rug.background}
                                border={rug.border}
                                show={true}
                            />
                        </div>
                    )
                    break;
            }
            return ""
        })
        return (
            <div className="selected-mobile-display">
                <p> {this.props.texts["selectedRugs"]} </p>
                <div className="ul-body relative">
                    {rugs}
                </div>
            </div>
        )
    }
}